import { styled } from '@mui/material/styles'
import React from 'react'

interface IOwnProps {
  label: string
  showLink?: boolean
}

export type IProps = IOwnProps

const LabelContainer = styled('div')({
  position: 'relative',
  fontWeight: '500',
  justifyContent: 'flex-start',
  background: '#eee',
  padding: '15px 6px',
  fontSize: 13,
  lineHeight: '16px',
  borderRadius: 4,
  color: '#74777a',
  width: 64,
  boxSizing: 'border-box',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 'calc(100% - 2px)',
    width: 0,
    height: 0,
    borderTop: '23px solid rgba(0, 0, 0, 0)',
    borderBottom: '23px solid rgba(0, 0, 0, 0)',
    borderRight: '16px solid #eee',
    transition: 'border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s',
  },
})

const LinkLine = styled('div')({
  position: 'absolute',
  background: '#eee',
  top: 42,
  right: 32,
  width: 8,
  height: '100%',
})

const ProductLabel: React.FC<IProps> = (props) => {
  const { label, showLink = false } = props

  const labelWithoutSpaces = label.replaceAll(/\s+/ig, '')
  const lastDigits = labelWithoutSpaces.length > 4 ? `**${labelWithoutSpaces.slice(-4)}` : labelWithoutSpaces
  return (
    <>
      <LabelContainer>
        {lastDigits}
      </LabelContainer>
      {showLink && <LinkLine />}
    </>
  )
}

export default ProductLabel
